// extracted by mini-css-extract-plugin
export default {"btop":"c83cef4479 _8660015d93 _61ab823b5a","icon":"a5545d0b94 _5cbba29c62","btoppink":"_68b10e2603 _1a6ddd3012"};